import type React from 'react'

import { useArtBoardDisabled } from '@/hooks/selectors/useArtBoardDisabled'
import { EstimateMode, Frames, ImageMode, Theme } from './components'
import { Layout } from './components/Layout'
import css from './styles.module.css'

const Settings: React.FC = () => {
  // The artboard is off and no setting would be saved: the whole list locks.
  const artboardDisabled = useArtBoardDisabled()

  return (
    <div className={css.container}>
      <Theme disabled={artboardDisabled} />

      <Frames disabled={artboardDisabled} />

      <Layout disabled={artboardDisabled} />

      <EstimateMode disabled={artboardDisabled} />

      <ImageMode disabled={artboardDisabled} />
    </div>
  )
}

export default Settings
